// --- Views
import OfferSummaryForm from '@/views/e-commerce-v2/sub-routes/offer/OfferSummaryForm.vue';
import OfferThankYou from '@/views/e-commerce-v2/sub-routes/offer/OfferThankYou.vue';
import ErrorView from '@/views/shared/ErrorPageV2.vue';

export default [
  {
    path: '',
    redirect: { path: 'offer-summary-form' },
  },
  {
    path: 'offer-summary-form',
    component: OfferSummaryForm,
    meta: {
      headerIcon: 'back',
      hasNext: true,
      nextRoutePath: 'offer-thank-you',
    },
  },
  {
    path: 'offer-thank-you',
    component: OfferThankYou,
    meta: {
      headerIcon: false,
      hasNext: false,
    },
  },
  // Subflow general error route
  {
    path: 'error',
    component: ErrorView,
    meta: {
      headerIcon: false,
      navInfo: false,
      hasNext: true,
      nextRoutePath: '../payment-calculator',
      errorPayload: {
        errorType: 'general',
        errorMsg: 'subFlow',
        buttonText: 'continuePayment',
      },
    },
  },
  {
    path: '*',
    redirect: { path: 'error' },
  },
];
